import React, { useEffect, useState } from 'react';
import {
    Grid,
    Typography,
    Switch,
    Box,
    Divider,
    Button,
    CircularProgress
} from '@mui/material';

const TeamV2LeadCaptureContainer = ({ memberData, setMemberData, isNewMember = false }) => {
    // Mock state for lead capture mode
    const [leadCaptureModeOn, setLeadCaptureModeOn] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    // Handle toggle change
    const handleToggle = (event) => {
        if (isLoading) return;

        const isChecked = event.target.checked;
        console.log("Lead capture toggle switched:", isChecked);

        // Update local state
        setLeadCaptureModeOn(isChecked);
        setMemberData(prev => ({
            ...prev,
            leadCaptureModeOn: isChecked
        }));

        // Simulate API call
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setSnackbar({
                open: true,
                message: isChecked ? 'Lead capture mode enabled' : 'Lead capture mode disabled',
                severity: 'success'
            });
        }, 1000);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                overflow: 'hidden',
                position: 'relative'
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    padding: 2,
                    paddingBottom: 0,
                    backgroundColor: 'white',
                    borderBottom: '1px solid #e1e1e1',
                    flexShrink: 0
                }}
            >
                <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                        fontWeight: 'bold',
                        marginBottom: 2
                    }}
                >
                    Lead Capture
                </Typography>
            </Box>

            {/* Content */}
            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    backgroundColor: 'white'
                }}
            >
                <Box sx={{ padding: 2 }}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: '0.8rem',
                                    fontWeight: 600,
                                    color: "#828282"
                                }}
                            >
                                When lead capture mode is enabled, the lead form will pop up as soon as your profile is shared.
                            </Typography>
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            sm={4}
                            display="flex"
                            justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
                        >
                            {isLoading ? (
                                <CircularProgress size={24} />
                            ) : (
                                <Switch
                                    checked={Boolean(leadCaptureModeOn)}
                                    onChange={handleToggle}
                                />
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            <Divider sx={{ backgroundColor: '#e1e1e1' }} />
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            {/* Footer */}
            <Box
                sx={{
                    backgroundColor: 'white',
                    padding: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    boxShadow: '0 -2px 4px rgba(0,0,0,0.05)',
                    borderTop: '1px solid #e1e1e1',
                    flexShrink: 0
                }}
            >
                <Button variant="text" color="primary" disabled sx={{ textTransform: 'none', height: '34px' }}>
                    Reset to default
                </Button>

                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button variant="outlined" color="primary" disabled sx={{ textTransform: 'none', height: '34px' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" disabled sx={{ textTransform: 'none', height: '34px', width: '100px' }}>
                        Save
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default TeamV2LeadCaptureContainer;
